import { customerTagWithIdSchema } from "@redotech/redo-model/customer";
import * as z from "zod";

const subscribeKeywordSchema = z.object({
  id: z.string(),
  accountId: z.string(),
  keyword: z.string(),
  status: z.enum(["active", "inactive"]),
  tagLegacyIds: z.array(z.string()),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export type SubscribeKeyword = z.infer<typeof subscribeKeywordSchema>;

const _populatedSubscribeKeywordSchema = subscribeKeywordSchema.extend({
  tags: z.array(customerTagWithIdSchema),
  subscriberCount: z.number(),
});
export interface PopulatedSubscribeKeyword extends z.infer<
  typeof _populatedSubscribeKeywordSchema
> {}
export const populatedSubscribeKeywordSchema: z.ZodType<PopulatedSubscribeKeyword> =
  _populatedSubscribeKeywordSchema;
